<template>
  <div class="app-body" style="padding-bottom: 80px;">
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="合同编号：" prop="orderCode">
            <order-drop v-model="dataForm.orderCode"
                        placeholder="请输入订单编号" size="mini"></order-drop>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="optName+'仓库：'" prop="storageId">
            <storages v-model="dataForm.storageId" size="mini"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="optName+'时间：'" prop="operateTime">
            <el-date-picker
                v-model="dataForm.operateTime"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择时间"
                size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="经手人：" prop="operate_man">
            <el-input v-model="dataForm.operateMan" size="mini"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="备注：" prop="remark" style="margin-bottom: 0;">
            <el-input
                size="mini"
                v-model="dataForm.remark"
                placeholder="备注"
                type="textarea"
                resize="none"
                rows="4"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="凭证照片：" prop="imgs" style="margin-bottom: 0;">
            <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="table-bar">
        <tool-tip :value="true" v-if="showTip">TIPS：请先选择合同编号及{{ optName }}仓库</tool-tip>
        <tool-tip :value="true" v-else>TIPS：使用【TAB】键可快速切换下一行。只有输入{{ optName }}数量的行才会被保存。
        </tool-tip>
      </div>
      <el-table :data="dataForm.detailList" border style="width: 100%" height="500">
        <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column label="品番号" prop="productCode" align="center" v-if="productType==1">
        </el-table-column>
        <el-table-column label="SKU" prop="skuCode" align="center" v-if="productType==1">
        </el-table-column>
        <el-table-column label="品名" prop="productName" align="center">
        </el-table-column>
        <el-table-column label="中文品名" prop="nameZh" align="center" v-if="productType==1">
        </el-table-column>
        <el-table-column label="颜色" prop="productColor" align="center">
        </el-table-column>
        <el-table-column label="规格" prop="productSize" align="center">
        </el-table-column>
        <el-table-column label="幅宽" prop="productAttr1" align="center" v-if="productType==2">
        </el-table-column>
        <el-table-column label="克重" prop="productAttr2" align="center" v-if="productType==2">
        </el-table-column>
        <el-table-column v-if="type==1&&productType==2" label="供应商" prop="companyName" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column v-if="type==1&&productType==1" label="工厂" prop="factoryName" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column v-if="type==1" label="计划数" prop="count" align="center">
        </el-table-column>
        <el-table-column v-if="type==1" :label="`已${optName}数`" prop="receiveCount" align="center">
        </el-table-column>
        <el-table-column
            :label="`本次${optName}数`"
            header-align="center"
            align="center"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.realCount'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="scope.row.realCount" size="mini" @change="getTotalAmount"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div class="form-foot">
      <el-button type="primary" @click="dataFormSubmitHandle(false)">保存</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle(true)">保存并继续{{ optName }}
      </el-button>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import MultipleImageUpload from '@/components/MultipleImageUpload'
import moment from 'moment'
import { isNumber, moneyValidator } from '@/utils/validate'
import BigNumber from 'bignumber.js'

export default {
  components: { MultipleImageUpload },
  data () {
    return {
      id: '',
      storageId: '',
      dataForm: {},
      visible: false,
      loading: false,
      type: 1,
      productType: 1
    }
  },
  computed: {
    optName () {
      if (this.type == 1) {
        return '入库'
      }
      return '出库'
    },
    showTip () {
      return (!(this.dataForm.orderCode && this.dataForm.storageId))
    },
    detailRule () {
      return {
        count: [
          {
            validator: function (rule, value, callback) {
              if (!value) {
                return callback()
              }
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          {
            validator: moneyValidator,
            trigger: 'change',
          },
        ],
      }
    },
    dataRule () {
      return {
        orderCode: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }],
        operateTime: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }],
        storageId: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }],
        receiptAmount: [
          {
            validator: moneyValidator,
            trigger: 'change',
          }],
      }
    }
  },
  watch: {
    'dataForm.orderCode': {
      handler: function (newVal) {
        this.handleDetailList()
      }
    },
    'dataForm.storageId': {
      handler: function (newVal) {
        this.handleDetailList()
      }
    }
  },
  activated () {
    this.type = this.$route.query.type
    this.productType = this.$route.query.productType
    this.reset()
    this.$nextTick(() => {
      this.dataForm.orderCode = this.$route.query.orderCode
      this.dataForm.storageId = this.$route.query.storageId
    })
  },
  methods: {
    //加载出入库明细
    handleDetailList () {
      //入库
      if (this.type == 1) {
        //原料
        if (this.productType == 2) {
          this.getSendList()
          this.dataForm.reason = '采购入库'
        } else if (this.productType == 1) {
          this.getFactoryMakeDetail()
          this.dataForm.reason = '生产入库'
        }
      }
    },
    cancel () {
    },
    getTotalAmount () {
      let t = new BigNumber(0)
      this.dataForm.detailList.forEach(item => {
        let c = new BigNumber(item.realCount)
        let p = new BigNumber(item.price)
        if (c.isNaN() || p.isNaN()) {
          return
        }
        t = t.plus(c.multipliedBy(p))
      })
      this.dataForm.receiptAmount = t.toFixed(3)
    },
    //获取加工单明细
    async getFactoryMakeDetail () {
      if (!this.dataForm.orderCode) {
        return
      }
      this.loading = true
      try {
        const { data: res } = await this.$http.get(`/trade/factorymake/detail/list`, {
          params: {
            orderCode: this.dataForm.orderCode,
          }
        })
        this.loading = false
        let dataList = res.data.map(item => {
          return {
            ...item,
            productName: item.name,
            productCode: item.code,
            productColor: item.color,
            productSize: item.size,
            receiveCount: item.checkInCount,
            makeId: item.parentId,
            sourceTable: 'ma_factory_make_detail',
            sourceId: item.id,
            senderId: item.factoryId
          }
        })
        this.$set(this.dataForm, 'detailList', dataList)
      } catch (e) {
        this.loading = false
      }
    },
    async getSendList () {
      if (!this.dataForm.orderCode || !this.dataForm.storageId) {
        return
      }
      this.loading = true
      try {
        const { data: res } = await this.$http.get(`/purchase/send/list`, {
          params: {
            orderCode: this.dataForm.orderCode,
            storageId: this.dataForm.storageId
          }
        })
        this.loading = false
        let dataList = res.data.map(item => {
          return {
            ...item
          }
        })
        this.$set(this.dataForm, 'detailList', dataList)
      } catch (e) {
        this.loading = false
      }
    },
    reset (keep) {
      this.imgArr = []
      let tmp = {
        id: '',
        remark: '',
        orderCode: '',
        receiptCode: '',
        receiptAmount: '',
        operateTime: moment().format('yyyy-MM-DD'),
        storageId: '',
        imgs: '',
        detailList: [],
        operateMan: '',
        sourceTable: '',
        sourceId: '',
        reason: ''
      }
      if (keep) {
        tmp.orderCode = this.dataForm.orderCode
        tmp.storageId = this.dataForm.storageId
      }
      this.dataForm = tmp
      if (keep) {
        this.handleDetailList()
      }
      this.$nextTick(() => {
        if (this.$refs['dataForm']) {
          this.$refs['dataForm'].clearValidate()
        }
      })
    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function (keep) {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }

                let postForm = {
                  ...this.dataForm,
                  type: this.type,
                  detailList: []
                }
                this.dataForm.detailList.forEach((item) => {
                  if (!item.realCount || item.realCount === 0) {
                    return
                  }
                  postForm.detailList.push({
                    ...item,
                    id: '',
                    count: item.realCount,
                    senderId: item.senderId ? item.senderId : item.sellorId,
                    price: 0
                  })
                })
                if (postForm.detailList.length === 0) {
                  return this.$message.error('明细不能为空')
                }
                this.loading = true
                this.$http
                    .post('/store/form', postForm)
                    .then(({ data: res }) => {
                      this.loading = false
                      if (res.code !== 0) {
                        return this.$message.error(res.msg)
                      }
                      this.$c.success('保存成功').then(() => {
                        if (keep) {
                          this.reset(keep)
                        } else {
                          this.$router.back()
                        }
                      })
                    })
                    .catch((e) => {
                      this.loading = false
                    })
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
